var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTryOns(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2343 18.3479C29.2343 18.3479 16.6083 10.0159 16.1146 9.81432V8.14492C17.6728 7.7059 18.7148 6.25129 18.7148 4.53667C18.7148 2.46782 17.0473 0.787109 15.001 0.787109C14.0122 0.793587 13.0663 1.19197 12.3708 1.89488C11.6754 2.59779 11.287 3.54784 11.291 4.53667C11.291 5.08874 11.7376 5.53341 12.2916 5.53341C12.8436 5.53341 13.0942 4.88902 13.0942 4.33694C13.0942 3.37223 14.1211 2.48854 15.0613 2.48854C16.0034 2.48854 16.9851 3.57196 16.9851 4.53667C16.9851 5.4995 15.9412 6.28521 14.9991 6.28521C14.4452 6.28521 14.1079 6.73176 14.1079 7.28195V9.77287C13.7348 9.91041 0.927933 18.3479 0.927933 18.3479C-0.0198206 19.3145 -1.3105 23.2129 3.20028 23.2129H26.9054C31.0394 23.2129 30.1406 19.2674 29.2343 18.3479ZM27.3783 21.4493H2.69343C1.42913 21.4493 1.46493 20.0248 2.03961 19.403L14.0024 11.8361C14.6487 11.4931 15.4608 11.4479 16.0995 11.8285L28.1019 19.4049C28.6803 20.0267 28.5371 21.4493 27.3783 21.4493Z",
    fill: "var(--klothed-textColor)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTryOns);
export default __webpack_public_path__ + "static/media/tryOns.8e804a98e7414bc8da012e1374de831b.svg";
export { ForwardRef as ReactComponent };